import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class AdminSubscriptionsToProcessDetailsResponse {
  @jsonMember(Boolean)
  public readonly isBulkProcessAvailable!: boolean;

  @jsonMember(Number)
  public readonly itemsToProcess!: number;

  @jsonMember(Date)
  public readonly nextScheduledProcessingDate!: Date;
}
